import styled from 'styled-components';

export const FilePreviewResultWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100%;
    background: ${({theme}) => theme.palette.background.paper};
    border: 1px solid ${({theme}) => theme.palette.dividers.subtle};
    overflow-y: auto;
    padding: 0 16px;
`;